import * as React from 'react'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl';

import { SocialIcon } from 'react-social-icons';
import { fonts } from '../../styles/variables'
import { FiEdit } from 'react-icons/fi'


const StyledBookingTextDiv = styled.div`
width:100%;
`;

const P = styled.p`
font-family: "Theano Didot", Regular;
font-size: 1.22em;
line-height: 30px;
color:rgb(68, 68, 68);
margin-bottom:0;
text-align:center;

  @media screen and (max-width: 1200px) {
text-align:center;

   }

`;

const Div = styled.div`
width:100%;

padding-right:2%;
padding-left:2%;

  @media screen and (max-width: 1200px) {
text-align:center;
height:auto;
margin:auto;
width:100%;
   }

`

const SocialDiv = styled.div`
text-align:center;

  @media screen and (max-width: 1200px) {
text-align:center;

   }

`

const StyledP = styled.p`
font-family: "Theano Didot", Regular;
font-style: italic;
font-size: 180%;
text-align: center;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
margin-bottom:20px;

  @media screen and (max-width: 1200px) {
text-align:center;

   }


`;


const EditButton = styled.div`
z-index:999999;
cursor:pointer;
width:48px;
margin-bottom:10px;
//margin-top:20px;
height:48px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: #fff;


}

:hover:before {
  height: 100%;

}

   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;



const EditBookingDetails = styled.div`
cursor:pointer;
text-align:center;
transition:all .2s ease;
display:none;


span {
color: #188cec;
cursor:pointer;
font-weight: bold !important;
font-size: 16px !important;
}

   @media screen and (max-width: 1295px) {
display:block;
}
`



interface BookingTextDivProps {
  className?: string
  openBottom?: any
  sheetOpen?: any
}



const BookingTextDiv: React.FC<BookingTextDivProps> = ({ openBottom,  sheetOpen }) => (

  <StyledBookingTextDiv>


    <Div>
      <StyledP><FormattedMessage id="booking_text_0" /> </StyledP>

      <EditBookingDetails style={{opacity: sheetOpen? 0:1}} onClick={openBottom}>

        <EditButton > <FiEdit/></EditButton>
        <FormattedMessage id="booking_text_00" />
      </EditBookingDetails>
      <br/>
      <P> <FormattedMessage id="booking_text_01" /> <br/>
        <FormattedMessage id="booking_text_02" /><br/>

        <FormattedMessage id="booking_text_03" /> <br/>

        <FormattedMessage id="booking_text_05" /> <a href={'mailto:info@vilhelm7.de'}>info@vilhelm7.de</a>  </P>

      <SocialDiv>
        <SocialIcon style={{ height: 65, width: 65 }} url="mailto:info@vilhelm7.de" network="email" fgColor="#828282" bgColor="#fff" />
      </SocialDiv>
<br/>



    </Div>

  </StyledBookingTextDiv>

)

export default BookingTextDiv
